import React, { useState } from 'react';
import TertiaryCustomButton from '../../../../../commons/tertiary-custom-button/tertiary-custom-button';
// import React, { useState } from "react";
// import TertiaryCustomButton from "../TertiaryCustomButton";

export default function SectionItem({ item, onNext }) {

  const { sections = [], view_all } = item.content;
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeCategoryIndex, setActiveCategoryIndex] = useState(null);

  // Toggle main menu open on heading click
  const toggleMenuOpen = () => {
    onNext(sections,item.title);
  };

  // Category button click: activate category, call onNext
  const handleCategoryClick = (index, category) => {
    console.log('sections category.items', category.items);
    setActiveCategoryIndex(index);
    console.log('useEffect item.title', item.title)
    onNext(category.items,item.title,'');
  };

  return (
    <li className="category-item">
      <TertiaryCustomButton
        title={item.title}
        onClick={toggleMenuOpen}
        classes={'customize-tertiary-cls'}
      />

      {isMenuOpen && (
        <div className="industries-menu">
          <div
            className="industries-buttons"
            style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
            {sections.map((cat, idx) => (
              <TertiaryCustomButton
                key={idx}
                classes={`customize-tertiary-cls ${
                  activeCategoryIndex === idx ? 'active' : ''
                }`}
                title={cat.title}
                onClick={() => handleCategoryClick(idx, cat)}
              />
            ))}
          </div>

          {/* Show sub-items of active category */}
          {activeCategoryIndex !== null && (
            <div className="dropdown-items" style={{ marginTop: '1rem' }}>
              <h4>{sections[activeCategoryIndex].title}</h4>
              <ul>
                {sections[activeCategoryIndex].items.map((subItem, i) => (
                  <li key={i}>
                    <a href="#" className="menu-link">
                      {subItem}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {/* View all industries link */}
          {view_all && (
            <div className="view-all" style={{ marginTop: '1rem' }}>
              <a href={view_all.href}>{view_all.text}</a>
            </div>
          )}
        </div>
      )}
    </li>
  );
}
